enum PageState {
  Loading,
  Loaded,
  ConnectionError,
  AccessDenied
}

export default PageState;